"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportError = void 0;
class TransportError extends Error {
    constructor(status, url, error) {
        super();
        this.status = status;
        this.url = url;
        this.error = error;
        this.name = this.constructor.name;
    }
}
exports.TransportError = TransportError;
//# sourceMappingURL=transport-error.js.map